import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

// 布局组件
import AppLayout from '@/components/layout/Layout'

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('@/views/login/Login'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/',
    component: AppLayout,
    redirect: '/dataBoard',
    children: [
      {
        path: 'dataBoard',
        name: 'DataBoard',
        component: () => import('@/views/home/dataBoard'),
        meta: { title: '数据看板', requiresAuth: true }
      },
      {
        path: 'assessment',
        name: 'AssessmentReport',
        component: () => import('@/views/reports/AssessmentReport'),
        meta: { title: '评估明细表', requiresAuth: true }
      },
      {
        path: 'auction',
        name: 'AuctionReport',
        component: () => import('@/views/reports/AuctionReport'),
        meta: { title: '拍卖明细', requiresAuth: true }
      },
      {
        path: 'dealer',
        name: 'DealerReport',
        component: () => import('@/views/reports/DealerReport'),
        meta: { title: '特约店报表', requiresAuth: true }
      },
      {
        path: 'platform',
        name: 'PlatformReport',
        component: () => import('@/views/reports/PlatformReport'),
        meta: { title: '拍卖平台报表', requiresAuth: true }
      },
      {
        path: 'downLoad',
        name: 'ReportDownLoad',
        component: () => import('@/views/reports/ReportDownLoad'),
        meta: { title: '报表下载', requiresAuth: true }
      },
      {
        path: 'store',
        name: 'StoreReport',
        component: () => import('@/views/reports/StoreReport'),
        meta: { title: '特约店管理', requiresAuth: true }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/system/UserManagement'),
        meta: { title: '用户管理', requiresAuth: true }
      }
    ]
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Honda报表系统'
  
  // 判断是否需要登录权限
  if (to.meta.requiresAuth) {
    const token = getToken()
    if (token) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else {
    next()
  }
})

export default router 